import React from "react";
import {
  BlockContentValue,
  PartialSanityImageType
} from "@silversea-ssc/ui-components-react";
import EmotionalLauncher, {
  EmotionalLauncherVariant
} from "components/EmotionalLauncher/EmotionalLauncher";
import * as styles from "./EmotionalLauncherCountdown.module.scss";
import { ConfiguredInstantSearch } from "components/Algolia/ConfiguredInstantSearch";
import { FYCQuery } from "components/FindYourCruise/FYCQueryBuilder";
import { CruisesCounter } from "../EmotionalLauncherCruiseCount/EmotionalLauncherCruiseCount";
import Countdown from "components/Countdown/Countdown";
import { t } from "@lingui/core/macro";
import type { TokenValues } from "@silversea-ssc/dotcom-read-model-types/Tokens";
import ConfiguredConfigure from "components/Algolia/ConfiguredConfigure";
import { forceResTimezone } from "src/utils/date/forceResTimezone";

type Props = {
  backgroundImage: PartialSanityImageType | undefined;
  title: string | BlockContentValue;
  content: BlockContentValue | undefined;
  searchQuery?: FYCQuery;
  searchIndexName?: string;
  expireDate: Date;
  countdownLabel?: string;
  variant?: EmotionalLauncherVariant;
  tokens?: TokenValues;
};

const EmotionalLauncherCountdown: React.FC<React.PropsWithChildren<Props>> = ({
  backgroundImage,
  title,
  content,
  children,
  searchIndexName,
  searchQuery,
  expireDate,
  countdownLabel,
  variant,
  tokens
}) => {
  return (
    <EmotionalLauncher
      title={title}
      content={content}
      backgroundImage={backgroundImage}
      variant={variant}
      tokens={tokens}
      subTitle={
        <div className={styles.subtitleContainer}>
          {searchQuery && searchIndexName && (
            <ConfiguredInstantSearch indexName={searchIndexName}>
              <ConfiguredConfigure
                filters={searchQuery}
                attributesToRetrieve={[]}
                distinct
              />
              <CruisesCounter />
            </ConfiguredInstantSearch>
          )}
          <React.Suspense fallback={null}>
            <Countdown
              expireDate={forceResTimezone(expireDate)}
              variant={"small"}
              label={countdownLabel ?? t`OFFER ENDS IN`}
            />
          </React.Suspense>
        </div>
      }
    >
      {children}
    </EmotionalLauncher>
  );
};

export default EmotionalLauncherCountdown;
